<template>
  <div class="clock-room-page">
    <header class="filter-header">
      <label class="search-box">
        <input
          v-model.trim="keyword"
          type="search"
          placeholder="请输入技师号查询"
          aria-label="请输入技师号查询"
        />
        <span class="search-icon" aria-hidden="true"></span>
      </label>

      <nav class="category-tabs" aria-label="技师分类">
        <button
          v-for="category in categoryList"
          :key="category"
          type="button"
          class="category-tab"
          :class="{ active: activeCategory === category }"
          @click="changeCategory(category)"
        >
          {{ category }}
        </button>
      </nav>
    </header>

    <main class="clock-room-content">
      <div class="status-summary">
        <button
          v-for="status in statusSummary"
          :key="status.key"
          type="button"
          class="summary-item"
          :class="{ active: activeStatus === status.key }"
          @click="changeStatus(status.key)"
        >
          <span>{{ status.label }}</span>
          <strong>{{ status.count }}</strong>
        </button>
      </div>

      <section
        v-for="group in groupedTechnicians"
        :key="group.name"
        class="technician-group"
      >
        <h2 class="group-title">
          {{ group.name }}
          <strong>{{ group.items.length }}</strong>
        </h2>

        <ul class="technician-grid">
          <li
            v-for="item in group.items"
            :key="item.id"
            class="technician-card"
            :class="[
              `card-${item.status}`,
              { 'selected-technician': selectedTechnicianId === item.id },
            ]"
            @click="toggleTechnicianSelection(item.id)"
          >
            <div class="card-main">
              <div class="technician-top">
                <strong class="technician-number">{{ item.code }}</strong>
                <span
                  class="gender"
                  :class="item.gender === '男' ? 'male' : 'female'"
                >
                  <i class="person-icon" aria-hidden="true"></i>
                  {{ item.shift }}
                </span>
              </div>

              <template v-if="item.status === 'reserved'">
                <div class="hand-code">{{ item.handCode }}</div>
                <div class="reserve-time">
                  <span class="calendar-icon" aria-hidden="true"></span>
                  {{ item.reserveTime }}
                </div>
              </template>

              <template v-else-if="item.status === 'waiting' || item.status === 'working'">
                <div class="clock-line">
                  <span class="hand-code">{{ item.handCode }}</span>
                  <strong><i class="hourglass-icon" aria-hidden="true"></i>{{ item.elapsed }}</strong>
                </div>
                <p class="project-line">{{ item.project }}</p>
              </template>

              <div v-if="item.showClockCounts" class="clock-counts">
                点：{{ item.point }} 跳：{{ item.jump }} 排：{{ item.queue }} 加：{{ item.extra }}
              </div>
            </div>

            <div class="status-bar">{{ getStatusLabel(item.status) }}</div>
          </li>
        </ul>
      </section>

      <div v-if="groupedTechnicians.length === 0" class="empty-state">
        暂无符合条件的技师
      </div>
    </main>

    <transition name="sheet">
      <div
        v-if="selectedTechnician"
        class="action-mask"
        role="presentation"
        @click.self="closeActionSheet"
      >
        <section class="action-sheet" role="dialog" aria-modal="true">
          <div class="sheet-title">
            <div>
              <strong>{{ selectedTechnician.code }}号技师</strong>
              <span>{{ getStatusLabel(selectedTechnician.status) }}</span>
            </div>
            <button
              type="button"
              class="sheet-close-icon"
              aria-label="关闭弹窗"
              @click="closeActionSheet"
            >
              ×
            </button>
          </div>

          <div class="action-grid">
            <button
              v-for="action in availableActions"
              :key="action.key"
              type="button"
              class="action-button"
              :class="{ danger: action.danger }"
              @click="handleTechnicianAction(action.key)"
            >
              {{ action.label }}
            </button>
          </div>

          <button type="button" class="sheet-cancel" @click="closeActionSheet">
            关闭弹窗
          </button>
        </section>
      </div>
    </transition>

    <myFooter />
  </div>
</template>

<script>
import myFooter from "@/components/myFooter";

const ALL_CATEGORY = "全部";
const ALL_STATUS = "all";

export default {
  name: "JiShiClockRoom",
  components: {
    myFooter,
  },
  data() {
    return {
      keyword: "",
      activeCategory: ALL_CATEGORY,
      activeStatus: ALL_STATUS,
      selectedTechnicianId: null,
      categoryList: [ALL_CATEGORY, "中医技师", "SPA技师", "按摩技师", "搓澡技师"],
      statusOptions: [
        { key: ALL_STATUS, label: "全部" },
        { key: "idle", label: "空闲" },
        { key: "working", label: "按摩中" },
        { key: "onClock", label: "上钟" },
      ],
      // 页面只依赖这一份原始数据。接口接入后，将返回数组转换为相同字段并替换它即可。
      technicianList: [
        { id: 1, code: "01", category: "中医技师", group: "美容技师", gender: "男", shift: "中班", status: "waiting", handCode: "0003", elapsed: "00:23", project: "颈肩按摩/6001/点/安安", point: 2, jump: 2, queue: 2, extra: 2, showClockCounts: true },
        { id: 2, code: "02", category: "中医技师", group: "美容技师", gender: "男", shift: "中班", status: "onClock", handCode: "0009", elapsed: "00:36", project: "颈肩按摩/6001/点/安安", point: 1, jump: 2, queue: 2, extra: 2, showClockCounts: true },
        { id: 3, code: "03", category: "SPA技师", group: "美容技师", gender: "女", shift: "中班", status: "idle", point: 1, jump: 2, queue: 2, extra: 2, showClockCounts: true },
        { id: 4, code: "04", category: "中医技师", group: "美容技师", gender: "男", shift: "中班", status: "idle", point: 1, jump: 2, queue: 2, extra: 2, showClockCounts: true },
        { id: 5, code: "05", category: "SPA技师", group: "美容技师", gender: "女", shift: "中班", status: "idle", point: 1, jump: 2, queue: 2, extra: 2, showClockCounts: true },
        { id: 6, code: "06", category: "SPA技师", group: "美容技师", gender: "女", shift: "中班", status: "reserved", handCode: "0009", reserveTime: "12.26 15:30", point: 1, jump: 2, queue: 2, extra: 2, showClockCounts: true },
        { id: 7, code: "07", category: "按摩技师", group: "按摩技师", gender: "女", shift: "中班", status: "working", handCode: "0009", elapsed: "00:36", project: "颈肩按摩/6001/点/安安", point: 1, jump: 2, queue: 2, extra: 2, showClockCounts: true },
        { id: 8, code: "08", category: "按摩技师", group: "按摩技师", gender: "女", shift: "中班", status: "working", handCode: "0009", elapsed: "00:36", project: "颈肩按摩/6001/点/安安", point: 1, jump: 2, queue: 2, extra: 2, showClockCounts: true },
        { id: 9, code: "09", category: "按摩技师", group: "按摩技师", gender: "女", shift: "", status: "offDuty", showClockCounts: false },
        { id: 10, code: "10", category: "按摩技师", group: "按摩技师", gender: "女", shift: "", status: "reversed", showClockCounts: false },
        { id: 11, code: "11", category: "中医技师", group: "按摩技师", gender: "男", shift: "中班", status: "idle", point: 1, jump: 2, queue: 2, extra: 2, showClockCounts: true },
        { id: 12, code: "12", category: "按摩技师", group: "按摩技师", gender: "女", shift: "", status: "stopped", showClockCounts: false },
        { id: 13, code: "13", category: "按摩技师", group: "按摩技师", gender: "女", shift: "中班", status: "idle", point: 1, jump: 2, queue: 2, extra: 2, showClockCounts: true },
        { id: 14, code: "14", category: "搓澡技师", group: "按摩技师", gender: "女", shift: "中班", status: "idle", point: 1, jump: 2, queue: 2, extra: 2, showClockCounts: true },
        { id: 15, code: "15", category: "搓澡技师", group: "按摩技师", gender: "女", shift: "中班", status: "idle", point: 1, jump: 2, queue: 2, extra: 2, showClockCounts: true },
      ],
    };
  },
  computed: {
    /**
     * 先应用顶部技师类型和搜索条件，但不应用状态条件。
     * 统计栏以这份数据计算，确保切换类型或搜索技师号时，各状态数量同步更新。
     */
    categoryFilteredList() {
      const normalizedKeyword = this.keyword.toLowerCase();
      return this.technicianList.filter((item) => {
        const matchesCategory =
          this.activeCategory === ALL_CATEGORY || item.category === this.activeCategory;
        const matchesKeyword =
          !normalizedKeyword || item.code.toLowerCase().includes(normalizedKeyword);
        return matchesCategory && matchesKeyword;
      });
    },
    /**
     * 根据当前分类和搜索结果动态生成状态统计。
     * “全部”统计所有技师，其余状态只统计状态值完全相同的数据。
     */
    statusSummary() {
      return this.statusOptions.map((option) => ({
        ...option,
        count:
          option.key === ALL_STATUS
            ? this.categoryFilteredList.length
            : this.categoryFilteredList.filter((item) => item.status === option.key).length,
      }));
    },
    /**
     * 对最终可见的技师按 group 字段分组。
     * 使用 reduce 动态创建分组，因此接口增加、删除或调整分组时模板无需改动。
     */
    groupedTechnicians() {
      const visibleList = this.categoryFilteredList.filter(
        (item) => this.activeStatus === ALL_STATUS || item.status === this.activeStatus
      );
      const groupMap = visibleList.reduce((result, item) => {
        if (!result[item.group]) {
          result[item.group] = [];
        }
        result[item.group].push(item);
        return result;
      }, {});

      return Object.keys(groupMap).map((name) => ({
        name,
        items: groupMap[name],
      }));
    },
    /**
     * 根据已选 id 获取完整技师数据。
     * 不直接保存技师对象，避免列表数据更新后弹窗仍引用旧对象。
     */
    selectedTechnician() {
      return (
        this.technicianList.find((item) => item.id === this.selectedTechnicianId) || null
      );
    },
    /**
     * 根据选中技师的当前状态生成允许执行的按钮。
     * 所有业务规则集中在这里，后续增加状态或调整权限时无需修改弹窗模板。
     */
    availableActions() {
      if (!this.selectedTechnician) {
        return [];
      }

      const isOnDuty = this.isTechnicianOnDuty(this.selectedTechnician);
      const idleActions = [
        ...(isOnDuty ? [{ key: "startWaiting", label: "待钟" }] : []),
        ...(isOnDuty ? [{ key: "reserve", label: "预约" }] : []),
        { key: "leave", label: "请假" },
        { key: "vacation", label: "休假" },
        { key: "reverse", label: "倒牌" },
        isOnDuty
          ? { key: "dutyOff", label: "下班", danger: true }
          : { key: "dutyOn", label: "上班" },
      ];
      const onClockActions = [
        { key: "extraClock", label: "加钟" },
        { key: "changeClock", label: "换钟" },
        { key: "returnClock", label: "退钟", danger: true },
        { key: "clockDown", label: "下钟" },
      ];
      const actionMap = {
        waiting: [
          { key: "clockUp", label: "上钟" },
          { key: "cancelWaiting", label: "取消待钟", danger: true },
        ],
        onClock: onClockActions,
        working: onClockActions,
        idle: idleActions,
        offDuty: [
          { key: "leave", label: "请假" },
          { key: "vacation", label: "休假" },
          { key: "reverse", label: "倒牌" },
          { key: "dutyOn", label: "上班" },
        ],
        reserved: [
          { key: "cancelReservation", label: "取消预约", danger: true },
          { key: "fulfillReservation", label: "兑现预约" },
        ],
        leave: [{ key: "restoreIdle", label: "恢复空闲" }],
        vacation: [{ key: "restoreIdle", label: "恢复空闲" }],
        reversed: [{ key: "restoreIdle", label: "恢复空闲" }],
        stopped: [{ key: "restoreIdle", label: "恢复空闲" }],
        overtimeWaiting: [
          { key: "cancelOvertimeWaiting", label: "取消超待钟", danger: true },
          { key: "topOvertimeWaiting", label: "超待钟置顶" },
          { key: "editOvertimeWaiting", label: "修改超待钟" },
          { key: "fulfillOvertimeWaiting", label: "兑现" },
        ],
      };

      return actionMap[this.selectedTechnician.status] || [];
    },
  },
  methods: {
    /**
     * 判断空闲技师当前是否处于上班状态。
     * 接口提供 isOnDuty 布尔值时优先使用该值；现有演示数据未提供该字段，
     * 因此回退为根据 shift 班次是否有值判断，确保新旧数据结构都能正常工作。
     *
     * @param {Object} technician 需要判断的技师数据。
     * @returns {boolean} true 表示已上班，false 表示已下班。
     */
    isTechnicianOnDuty(technician) {
      if (typeof technician.isOnDuty === "boolean") {
        return technician.isOnDuty;
      }
      return Boolean(technician.shift);
    },
    /**
     * 切换顶部技师类型。
     * 切换后保留搜索关键词，并重置状态为“全部”，避免新分类中没有原状态数据时
     * 页面直接显示空白，让用户始终先看到该分类下的完整技师列表。
     *
     * @param {string} category 用户点击的技师类型名称。
     */
    changeCategory(category) {
      this.activeCategory = category;
      this.activeStatus = ALL_STATUS;
    },
    /**
     * 切换状态统计筛选。
     * 再次点击当前状态不会取消选择，保证页面始终具有明确的筛选条件。
     *
     * @param {string} status 状态键，对应 technicianList 每条数据的 status 字段。
     */
    changeStatus(status) {
      this.activeStatus = status;
    },
    /**
     * 切换技师卡片的单选状态。
     * 点击未选中的技师时记录其 id，此前选中的卡片会自动失去选中样式；
     * 再次点击当前技师时将 id 清空，从而实现取消选中。
     *
     * @param {number|string} technicianId 当前点击技师的唯一标识。
     */
    toggleTechnicianSelection(technicianId) {
      this.selectedTechnicianId =
        this.selectedTechnicianId === technicianId ? null : technicianId;
    },
    /**
     * 关闭底部操作弹窗并清除卡片选中态。
     * 遮罩、右上角关闭图标和底部关闭按钮都会复用此方法。
     */
    closeActionSheet() {
      this.selectedTechnicianId = null;
    },
    /**
     * 执行技师操作并同步演示数据。
     * 方法先向父级抛出 technician-action 事件，事件包含操作键和技师数据，
     * 便于后续接入接口；随后按操作结果更新本地状态，并关闭操作弹窗。
     *
     * @param {string} actionKey availableActions 中定义的操作键。
     */
    handleTechnicianAction(actionKey) {
      if (!this.selectedTechnician) {
        return;
      }

      const technician = this.selectedTechnician;
      this.$emit("technician-action", {
        action: actionKey,
        technician: { ...technician },
      });

      const nextStatusMap = {
        startWaiting: "waiting",
        reserve: "reserved",
        clockUp: "onClock",
        cancelWaiting: "idle",
        returnClock: "idle",
        clockDown: "idle",
        leave: "leave",
        vacation: "vacation",
        reverse: "reversed",
        dutyOff: "offDuty",
        dutyOn: "idle",
        cancelReservation: "idle",
        fulfillReservation: "onClock",
        restoreIdle: "idle",
        cancelOvertimeWaiting: "idle",
        fulfillOvertimeWaiting: "onClock",
      };

      if (actionKey === "extraClock") {
        technician.extra = Number(technician.extra || 0) + 1;
      } else if (actionKey === "topOvertimeWaiting") {
        const technicianIndex = this.technicianList.findIndex(
          (item) => item.id === technician.id
        );
        if (technicianIndex > 0) {
          const selectedItem = this.technicianList.splice(technicianIndex, 1)[0];
          this.technicianList.unshift(selectedItem);
        }
      } else if (nextStatusMap[actionKey]) {
        technician.status = nextStatusMap[actionKey];
        if (actionKey === "dutyOff") {
          technician.isOnDuty = false;
          technician.shift = "";
        } else if (actionKey === "dutyOn") {
          technician.isOnDuty = true;
          technician.shift = technician.shift || "中班";
        } else if (actionKey === "restoreIdle") {
          technician.isOnDuty = true;
          technician.shift = technician.shift || "中班";
        }
      }

      this.closeActionSheet();
    },
    /**
     * 将数据状态转换成卡片底部的中文文案。
     * 未识别的状态统一显示“未知”，避免接口新增状态时出现空白状态栏。
     *
     * @param {string} status 技师当前状态。
     * @returns {string} 展示在卡片底部的状态名称。
     */
    getStatusLabel(status) {
      const statusLabelMap = {
        waiting: "待钟",
        onClock: "上钟",
        idle: "空闲",
        reserved: "预约",
        working: "上钟",
        offDuty: "下班",
        reversed: "倒牌",
        stopped: "停牌",
        leave: "请假",
        vacation: "休假",
        overtimeWaiting: "超待钟",
      };
      return statusLabelMap[status] || "未知";
    },
  },
};
</script>

<style scoped lang="scss">
.clock-room-page {
  min-height: 100vh;
  padding-bottom: calc(100px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  color: #242528;
  background: #f7f1e7;
}

.filter-header {
  background: #eee6da;
}

.search-box {
  position: relative;
  display: block;
  padding: 16px 18px 14px;
  background: #f7f4ef;

  input {
    width: 100%;
    height: 54px;
    padding: 0 72px 0 34px;
    border: 0;
    border-radius: 27px;
    box-sizing: border-box;
    color: #333;
    background: #fff;
    font-size: 24px;
    outline: 0;
  }

  input::placeholder {
    color: #b4a276;
  }
}

.search-icon {
  position: absolute;
  right: 48px;
  top: 31px;
  width: 18px;
  height: 18px;
  border: 3px solid #aa9766;
  border-radius: 50%;

  &::after {
    content: "";
    position: absolute;
    right: -10px;
    bottom: -8px;
    width: 12px;
    height: 3px;
    background: #aa9766;
    transform: rotate(45deg);
    transform-origin: left center;
  }
}

.category-tabs {
  display: flex;
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.category-tab {
  position: relative;
  flex: 0 0 auto;
  min-width: 136px;
  height: 80px;
  padding: 0 22px;
  border: 0;
  color: #282828;
  background: transparent;
  font-size: 27px;

  &.active::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 56px;
    height: 5px;
    border-radius: 3px 3px 0 0;
    background: #252932;
    transform: translateX(-50%);
  }
}

.clock-room-content {
  padding: 22px 20px 30px;
}

.status-summary {
  display: flex;
  align-items: center;
  height: 52px;
  margin-bottom: 20px;
  overflow-x: auto;
  border-radius: 28px;
  background: #fff;
  box-shadow: inset 0 0 0 1px #e5d8c4;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.summary-item {
  position: relative;
  display: flex;
  flex: 1 0 142px;
  align-items: center;
  justify-content: center;
  gap: 18px;
  height: 100%;
  padding: 0 16px;
  border: 0;
  color: #aa9361;
  background: transparent;
  font-size: 24px;
  white-space: nowrap;

  strong {
    font-weight: 600;
  }

  &:not(:last-child)::after {
    content: "";
    position: absolute;
    right: 0;
    width: 1px;
    height: 28px;
    background: #ded8ce;
  }

  &.active {
    border-radius: 28px;
    background: #f3eadc;
    box-shadow: inset 0 0 0 1px #ddcbae;
  }
}

.technician-group + .technician-group {
  margin-top: 24px;
}

.group-title {
  margin: 0 10px 10px;
  font-size: 27px;
  font-weight: 500;

  strong {
    margin-left: 12px;
    color: #a98e54;
    font-weight: 600;
  }
}

.technician-grid {
  display: flex;
  flex-wrap: wrap;
  margin: -10px;
  padding: 0;
  list-style: none;
}

.technician-card {
  display: flex;
  width: calc(50% - 20px);
  min-width: 0;
  height: 258px;
  margin: 10px;
  overflow: hidden;
  flex-direction: column;
  border: 2px solid #d7d8dc;
  border-radius: 15px;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 3px 8px rgba(55, 56, 64, 0.08);
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  -webkit-tap-highlight-color: transparent;
}

.technician-card.selected-technician {
  border-color: #f2535e;
  box-shadow: 0 0 0 1px rgba(242, 83, 94, 0.12);
}

.card-main {
  position: relative;
  display: flex;
  flex: 1;
  min-height: 0;
  padding: 16px 16px 10px;
  overflow: hidden;
  flex-direction: column;
  box-sizing: border-box;
}

.technician-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 0;
}

.technician-number {
  color: #292c31;
  font-size: 36px;
  font-weight: 500;
  line-height: 1;
}

.gender {
  display: flex;
  min-width: 0;
  align-items: center;
  color: #292c31;
  font-size: 25px;
  white-space: nowrap;

}

.person-icon {
  position: relative;
  display: inline-block;
  width: 15px;
  height: 26px;
  margin-right: 8px;
  border-radius: 8px 8px 3px 3px;
  background: currentColor;

  &::before {
    content: "";
    position: absolute;
    left: 4px;
    top: -10px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: currentColor;
  }
}

.gender.male {
  .person-icon {
    color: #3db8ef;
  }
}

.gender.female {
  .person-icon {
    color: #ff75c4;
  }
}

.hand-code {
  color: #ae9155;
  font-size: 23px;
  font-weight: 600;
}

.clock-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;

  strong {
    color: #f03d4d;
    display: flex;
    align-items: center;
    font-size: 34px;
    line-height: 1;
    white-space: nowrap;
  }

}

.hourglass-icon {
  position: relative;
  width: 16px;
  height: 22px;
  margin-right: 7px;
  border-top: 3px solid currentColor;
  border-bottom: 3px solid currentColor;
  box-sizing: border-box;

  &::before,
  &::after {
    content: "";
    position: absolute;
    left: 3px;
    width: 10px;
    height: 10px;
    border-right: 2px solid currentColor;
    border-bottom: 2px solid currentColor;
    box-sizing: border-box;
  }

  &::before {
    top: 0;
    transform: rotate(45deg);
  }

  &::after {
    bottom: 0;
    transform: rotate(225deg);
  }
}

.project-line {
  margin: 12px 0 0;
  overflow: hidden;
  color: #6b6b6b;
  font-size: 22px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.clock-counts {
  margin-top: auto;
  overflow: hidden;
  color: #7f776b;
  font-size: 21px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.reserve-time {
  display: flex;
  align-items: center;
  margin-top: 20px;
  color: #16c6df;
  font-size: 27px;
  font-weight: 600;
  white-space: nowrap;
}

.calendar-icon {
  position: relative;
  width: 24px;
  height: 22px;
  margin-right: 8px;
  border: 3px solid currentColor;
  border-radius: 4px;
  box-sizing: border-box;

  &::before {
    content: "";
    position: absolute;
    left: 3px;
    right: 3px;
    top: 5px;
    border-top: 2px solid currentColor;
  }

  &::after {
    content: "";
    position: absolute;
    right: -5px;
    bottom: -5px;
    width: 8px;
    height: 8px;
    border: 2px solid currentColor;
    border-radius: 50%;
    background: #f7ffff;
  }
}

.status-bar {
  display: flex;
  height: 52px;
  flex: 0 0 52px;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: linear-gradient(90deg, #8889b2, #b4b4d0);
  font-size: 28px;
}

.card-waiting {
  .status-bar {
    background: linear-gradient(90deg, #ed1f29, #ff5860);
  }
}

.card-onClock .status-bar {
  background: linear-gradient(90deg, #7e78ef, #9489f5);
}

.card-working .status-bar {
  background: linear-gradient(90deg, #627ce9, #52b4e9);
}

.card-reserved {
  border-color: #82dce0;
  background: #f7ffff;

  .status-bar {
    background: linear-gradient(90deg, #17bce5, #00dce5);
  }
}

.card-offDuty .status-bar,
.card-reversed .status-bar,
.card-stopped .status-bar,
.card-leave .status-bar,
.card-vacation .status-bar {
  background: linear-gradient(90deg, #9ba1a5, #d6d9dd);
}

.action-mask {
  position: fixed;
  z-index: 1000;
  inset: 0;
  display: flex;
  align-items: flex-end;
  background: rgba(0, 0, 0, 0.42);
}

.action-sheet {
  width: 100%;
  padding: 0 24px calc(24px + env(safe-area-inset-bottom));
  border-radius: 26px 26px 0 0;
  box-sizing: border-box;
  background: #f7f4ef;
  box-shadow: 0 -8px 28px rgba(0, 0, 0, 0.12);
}

.sheet-title {
  display: flex;
  height: 92px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e7ded2;

  div {
    display: flex;
    align-items: baseline;
  }

  strong {
    color: #27292d;
    font-size: 30px;
    font-weight: 600;
  }

  span {
    margin-left: 18px;
    color: #aa915d;
    font-size: 23px;
  }
}

.sheet-close-icon {
  display: flex;
  width: 50px;
  height: 50px;
  padding: 0;
  align-items: center;
  justify-content: center;
  border: 0;
  color: #8a8176;
  background: transparent;
  font-size: 42px;
  font-weight: 300;
  line-height: 1;
}

.action-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
  padding: 24px 0;
}

.action-button {
  height: 78px;
  border: 1px solid #cfb986;
  border-radius: 10px;
  color: #8d733c;
  background: #fff;
  font-size: 27px;
  font-weight: 500;

  &:active {
    background: #f1e7d6;
  }

  &.danger {
    border-color: #ef9ca2;
    color: #e34852;
    background: #fff8f8;
  }
}

.sheet-cancel {
  width: 100%;
  height: 78px;
  border: 0;
  border-radius: 10px;
  color: #4f4b46;
  background: #fff;
  box-shadow: inset 0 0 0 1px #e4ddd3;
  font-size: 27px;
}

.sheet-enter-active,
.sheet-leave-active {
  transition: background-color 0.2s ease;

  .action-sheet {
    transition: transform 0.2s ease;
  }
}

.sheet-enter,
.sheet-leave-to {
  background: rgba(0, 0, 0, 0);

  .action-sheet {
    transform: translateY(100%);
  }
}

.empty-state {
  padding: 120px 0;
  color: #aa9f8e;
  font-size: 26px;
  text-align: center;
}

@media screen and (max-width: 360px) {
  .clock-room-content {
    padding-right: 16px;
    padding-left: 16px;
  }

  .technician-grid {
    margin: -8px;
  }

  .technician-card {
    width: calc(50% - 16px);
    margin: 8px;
  }

  .card-main {
    padding-right: 12px;
    padding-left: 12px;
  }
}
</style>
